import clsx from "clsx";
import { useSyncExternalStore } from "react";
import { BOARD_CONFIG, MIX_BOARD_NAMES } from "@/config/browserBoard";
import { findMixLineupEntry } from "@/config/mixLineup";
import {
  getAddedBoardNames,
  subscribeAddedBoardNames,
} from "@/shared/lib/addedBoardNames";
import { resolveBoardIcon } from "@/shared/lib/boardIcon";

interface CatalogBoardIconProps {
  slug: string | undefined;
  className?: string;
}

/** mixカタログの取得元板を示す16px角の板アイコン。 */
export const CatalogBoardIcon: React.FunctionComponent<
  CatalogBoardIconProps
> = ({ slug, className }: CatalogBoardIconProps) => {
  const addedNames = useSyncExternalStore(
    subscribeAddedBoardNames,
    getAddedBoardNames,
    getAddedBoardNames,
  );
  const src = resolveBoardIcon(slug);
  if (slug === undefined) return null;
  const lineupEntry = findMixLineupEntry(slug);
  const runtimeName =
    (Object.hasOwn(MIX_BOARD_NAMES, slug)
      ? MIX_BOARD_NAMES[slug]
      : undefined) ??
    (slug === BOARD_CONFIG.boardKey ? BOARD_CONFIG.boardName : undefined);
  if (
    src === null &&
    !lineupEntry &&
    !Object.hasOwn(addedNames, slug) &&
    !runtimeName
  )
    return null;

  const label = runtimeName ?? addedNames[slug] ?? lineupEntry?.label ?? slug;
  if (src === null)
    return (
      <small
        title={label}
        className={clsx(
          "catalog-board-icon shrink-0 text-xs text-muted-foreground",
          className,
        )}
      >
        {label}
      </small>
    );
  return (
    <img
      src={src}
      alt={`${label}の板`}
      title={label}
      className={clsx(
        "catalog-board-icon h-4 w-4 shrink-0 object-contain",
        className,
      )}
    />
  );
};
